import { render, staticRenderFns } from "./App.vue?vue&type=template&id=59a2fdba&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=59a2fdba&prod&scoped=true&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=59a2fdba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a2fdba",
  null
  
)

export default component.exports